import {BrowserRouter  as Router,Routes,Route} from "react-router-dom";
import "./Languge/i18n";
import {Header,Footer} 
from './Component/index'



import {HomePage,BlogPage,NewsLettersPage,AllCoinPage} from './Page/index';
import ScrollToTop from "./Component/ScrollToTop/ScrollToTop";


 import Demo1 from "./Article/Detail1"



function App(){
  return(
    <Router>
        <>
         
          <ScrollToTop />
          <Header />
            <Routes>

                <Route index path="/" element={<HomePage />}></Route>
              

                <Route path="/blog/:filter?" element={<BlogPage />}></Route>
                <Route path="/newsletters" element={<NewsLettersPage />}></Route>
                <Route path="/all_coin" element={<AllCoinPage />}></Route>

                
                <Route path="/demo1" element={<Demo1 />}></Route>

                

            </Routes>
          <Footer />
        </>
    </Router>
  );
}

export default App;
